import {ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, inject, signal} from '@angular/core';
import {takeUntilDestroyed, toSignal} from '@angular/core/rxjs-interop';
import {RoutemapService} from '../../../core/services/routemap.service';
import {UtilsService} from '../../../core/utils/utils.service';
import {UnitesDeProductionService} from '../../../core/services/entities/unites-de-production.service';
import {GenericFormService} from '../../../core/services/generics/generic-form.service';
import {GenericDatagridService} from '../../../core/services/generics/generic-datagrid.service';
import {ActivatedRoute, Router} from '@angular/router';
import {UniteDeProductionSupplier} from '../unite-production-resolver.service';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {UniteDeProductionDTO} from '../../../core/dtos/unite-de-production-dto';
import {cloneDeep as _cloneDeep, orderBy as _orderBy, sortBy as _sortBy} from 'lodash';
import {FS_ROUTES, HELP_FOLDERS, JOURS_SEMAINES, MSG_KEY, MSG_SEVERITY} from '../../../core/constants';
import {SecteurDTO} from '../../../core/dtos/secteur-dto';
import {DialogMsgSupplier, Paragraphe} from '../../../core/suppliers/dialog-msg-supplier';
import {SecteurFournisseurDTO} from '../../../core/dtos/secteurfournisseur-dto';
import {SecteursFournisseursService} from '../../../core/services/entities/secteurs-fournisseurs.service';
import {
  FournisseurLivraisonsAffectationSupplier,
  UniteDeProduction__secteurFournisseurService
} from '../../../core/services/entities/unite-de-production__secteur-fournisseur.service';
import {UniteDeProduction__LivraisonDTO} from '../../../core/dtos/unite-de-production__livraison-dto';
import {Auth2Service} from '../../../core/services/security/auth2.service';
import {MenuItem} from 'primeng/api';
import {UniteDeProductionReglePrefereService} from '../../../core/services/entities/unite-de-production__regle-prefere.service';
import {ResponseWrapper} from '../../../core/suppliers/wrappers/response-wrapper';
import {confirm} from 'devextreme/ui/dialog';
import {ToastService} from '../../../core/services/technique/toast.service';
import {AdministrationService} from '../../../core/services/gestion-administration/administration.service';
import {ButtonThemeEnum} from '../../../shared/ui/button/button-theme-enum';


@Component({
  selector: 'yo-up-livraisons',
  templateUrl: './up-livraisons.component.html',
  styleUrls: ['./up-livraisons.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class UpLivraisonsComponent {

  readonly ButtonThemeEnum = ButtonThemeEnum;

  // Services
  readonly udpSvc = inject(UnitesDeProductionService);
  readonly udpSecteurFournisseurSvc = inject(UniteDeProduction__secteurFournisseurService);
  readonly gds = inject(GenericDatagridService);
  readonly utils = inject(UtilsService);
  private readonly auth2Svc = inject(Auth2Service);
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly routeMapSvc = inject(RoutemapService);
  private readonly gfs = inject(GenericFormService);
  private readonly cd = inject(ChangeDetectorRef);
  private readonly secteursFournisseursSvc = inject(SecteursFournisseursService);
  private readonly udpReglePrefereSvc = inject(UniteDeProductionReglePrefereService);
  private readonly adminService = inject(AdministrationService);
  private readonly toastSvc = inject(ToastService);
  private readonly destroyRef = inject(DestroyRef);

  // Signals
  readonly canWrite = toSignal(this.auth2Svc.hasUniteDeProductionLivWrite$, {initialValue: false});
  readonly hasAdministration = toSignal(this.auth2Svc.hasAdministration$, {initialValue: false});
  readonly displayNavFournisseurs = signal<boolean>(true);

  joursSemaineList = _cloneDeep(JOURS_SEMAINES);
  selectedJourSemaineList: { value, viewValue }[] = [];

  secteurList: SecteurDTO[] = [];
  selectedSecteurList: SecteurDTO[] = [];

  secteurFournisseurList: SecteurFournisseurDTO[] = [];
  selectedSecteurFournisseurList: SecteurFournisseurDTO[] = [];

  selectedJourSemaineKeyList: number[] = [];
  selectedSecteurKeyList: number[] = [];
  selectedSecteurFournisseurKeyList: number[] = [];

  affectationsSupplier: FournisseurLivraisonsAffectationSupplier;
  livraisonsOfUDP: UniteDeProduction__LivraisonDTO[] = [];

  form: FormGroup = new FormGroup({});
  formJoursLivraisonUDP: FormGroup = new FormGroup({});

  uniteDeProduction: UniteDeProductionDTO;

  navUpLivraison: MenuItem[] = [];
  activeItem: MenuItem;
  navUpLivraisonDx: any[] = [];
  activeItemDx: any;

  pathFile: string = HELP_FOLDERS.UNITE_DE_PRODUCTION + '/unites-production-livraisons';

  constructor() {
    this.initNavUpLivraison();
    this.routeSubscription();
    this.sideNavSubscription();
    this.subscriptionUdpLivraison();
    this.tabRouteSubscription();
    this.ensureDefaultLivraisonTab();
  }

  private routeSubscription = (): void => {
    this.route.parent.data
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data: { uniteDeProductionSupplier: UniteDeProductionSupplier }) => {
        this.uniteDeProduction = data.uniteDeProductionSupplier.uniteDeProduction;
        this.secteurList = data.uniteDeProductionSupplier.secteurList;
        this.secteurFournisseurList = [];
        if (!this.utils.isCollectionNullOrEmpty(data.uniteDeProductionSupplier.secteurFournisseurList)) {
          this.secteurFournisseurList = _sortBy(data.uniteDeProductionSupplier.secteurFournisseurList, ['secteur.code', 'fournisseurLibelle']);
        }
        this.livraisonsOfUDP = data.uniteDeProductionSupplier.livraisonsOfUDP;
        this.initForm(this.uniteDeProduction);
      });
  };

  private subscriptionUdpLivraison = (): void => {
    this.udpSecteurFournisseurSvc.udpLivraison$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
        this.livraisonsOfUDP = [...data];
      });
  };

  private sideNavSubscription = (): void => {
    this.routeMapSvc.sidenav$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.initForm(this.uniteDeProduction);
      });
  };

  private initNavUpLivraison = (): void => {
    this.navUpLivraison = [
      {label: 'Fournisseur', routerLink: [], queryParams: {tab: 'fournisseur'}},
      {label: 'Planning livraison', routerLink: [], queryParams: {tab: 'planning-livraison'}},
    ];
    this.activeItem = this.navUpLivraison[0];
    this.navUpLivraisonDx = this.navUpLivraison.map(item => ({...item, text: item.label}));
    this.applyLivraisonTabState(this.route.snapshot.queryParamMap.get('tab'));
  };

  initForm = (uniteDeProduction: UniteDeProductionDTO): void => {
    this.selectedJourSemaineList = [];
    if (!this.utils.isNullOrEmpty(uniteDeProduction) && !this.utils.isCollectionNullOrEmpty(uniteDeProduction.uniteDeProduction__jourLivraisonList)) {
      this.joursSemaineList.forEach(item => {
        uniteDeProduction.uniteDeProduction__jourLivraisonList.forEach(udpjs => {
          if (udpjs.numeroJourSemaine === item.value) {
            this.selectedJourSemaineList.push(item);
          }
        });
      });
    }
    this.selectedJourSemaineKeyList = this.selectedJourSemaineList.map(j => j.value);
    this.selectedSecteurList = this.gfs.initMatSelectionList(uniteDeProduction.uniteDeProduction__secteurList, this.secteurList, 'idSecteur', 'id');
    this.selectedSecteurKeyList = this.selectedSecteurList.map(s => s.id);
    this.formJoursLivraisonUDP = new FormGroup({
      joursSemaineUDP: new FormControl(this.selectedJourSemaineList, Validators.required),
      secteursUDP: new FormControl(this.selectedSecteurList, Validators.required),
      secteursFournisseursUDP: new FormControl(this.selectedSecteurFournisseurList)
    });
    this.getSecteursFournisseurs(this.selectedSecteurList);
    this.form = new FormGroup({formJoursLivraisonUDP: this.formJoursLivraisonUDP});
    this.cd.markForCheck();
  };

  private getSecteursFournisseurs = (secteurs: SecteurDTO[]) =>
    this.secteursFournisseursSvc.findSecteursFournisseursBySecteurs(secteurs)
      .toPromise()
      .then(response => {
        const resultList = _sortBy(response.resultList, ['secteur.code', 'fournisseurLibelle']);
        this.secteurFournisseurList = resultList;
        if (this.utils.isCollectionNullOrEmpty(secteurs)) {
          this.selectedSecteurFournisseurList = [];
        } else if (!this.utils.isCollectionNullOrEmpty(this.livraisonsOfUDP)) {
          this.selectedSecteurFournisseurList = resultList.filter(item =>
            this.livraisonsOfUDP.some(liv => liv.idSecteurFournisseur === item.id)
          );
        }
        this.selectedSecteurFournisseurKeyList = this.selectedSecteurFournisseurList.map(sf => sf.id);
        this.formJoursLivraisonUDP.controls['secteursFournisseursUDP'].setValue(this.selectedSecteurFournisseurList);
        this.affectationsSupplier = new FournisseurLivraisonsAffectationSupplier(this.selectedJourSemaineList, this.selectedSecteurFournisseurList, this.uniteDeProduction, this.livraisonsOfUDP, false);
        this.cd.markForCheck();
      });

  addToAffectationFournisseurs = (event: any): void => {
    if (!this.canWrite() || !this.gds.canModify(this.uniteDeProduction)) {
      this.selectedSecteurFournisseurKeyList = [...this.selectedSecteurFournisseurKeyList];
      this.cd.markForCheck();
      return;
    }
    if (event.addedItems?.length) {
      event.addedItems.forEach(item => {
        if (!this.selectedSecteurFournisseurKeyList.includes(item.id)) {
          this.selectedSecteurFournisseurKeyList.push(item.id);
        }
      });
    }
    if (event.removedItems?.length) {
      event.removedItems.forEach(item => {
        this.selectedSecteurFournisseurKeyList = this.selectedSecteurFournisseurKeyList.filter(id => id !== item.id);
      });
    }
    this.selectedSecteurFournisseurList = _sortBy(
      this.secteurFournisseurList.filter(sf => this.selectedSecteurFournisseurKeyList.includes(sf.id)),
      'fournisseurLibelle'
    );
    this.affectationsSupplier = new FournisseurLivraisonsAffectationSupplier(this.selectedJourSemaineList, this.selectedSecteurFournisseurList, this.uniteDeProduction, this.livraisonsOfUDP, true);
  };

  onChangeAffectations = (livraisonsOfUDP: UniteDeProduction__LivraisonDTO[]): void => {
    this.livraisonsOfUDP = livraisonsOfUDP;
  };

  onChangeSecteurs = (event: any): void => {
    if (!this.canWrite() || !this.gds.canModify(this.uniteDeProduction)) {
      this.selectedSecteurKeyList = [...this.selectedSecteurKeyList];
      this.cd.markForCheck();
      return;
    }
    if (event.addedItems?.length) {
      event.addedItems.forEach(item => {
        if (!this.selectedSecteurKeyList.includes(item.id)) {
          this.selectedSecteurKeyList.push(item.id);
        }
      });
    }
    if (event.removedItems?.length) {
      event.removedItems.forEach(item => {
        this.selectedSecteurKeyList = this.selectedSecteurKeyList.filter(id => id !== item.id);
      });
    }
    this.selectedSecteurList = this.secteurList.filter(s => this.selectedSecteurKeyList.includes(s.id));
    this.formJoursLivraisonUDP.controls['secteursUDP'].setValue(this.selectedSecteurList);
    this.formJoursLivraisonUDP.controls['secteursUDP'].markAsDirty();
    if (this.utils.isCollectionNullOrEmpty(this.selectedSecteurList)) {
      this.secteurFournisseurList = [];
    } else {
      this.getSecteursFournisseurs(this.selectedSecteurList);
    }
    this.affectationsSupplier = new FournisseurLivraisonsAffectationSupplier(this.selectedJourSemaineList, this.selectedSecteurFournisseurList, this.uniteDeProduction, this.livraisonsOfUDP, false);
  };

  onChangeJoursSemaine = (event: any): void => {
    if (!this.canWrite() || !this.gds.canModify(this.uniteDeProduction)) {
      this.selectedJourSemaineKeyList = [...this.selectedJourSemaineKeyList];
      this.cd.markForCheck();
      return;
    }
    if (event.addedItems?.length) {
      event.addedItems.forEach(item => {
        if (!this.selectedJourSemaineKeyList.includes(item.value)) {
          this.selectedJourSemaineKeyList.push(item.value);
        }
      });
    }
    if (event.removedItems?.length) {
      event.removedItems.forEach(item => {
        this.selectedJourSemaineKeyList = this.selectedJourSemaineKeyList.filter(v => v !== item.value);
      });
    }
    this.selectedJourSemaineList = _orderBy(
      this.joursSemaineList.filter(j => this.selectedJourSemaineKeyList.includes(j.value)),
      'value'
    );
    this.formJoursLivraisonUDP.controls['joursSemaineUDP'].setValue(this.selectedJourSemaineList);
    this.formJoursLivraisonUDP.controls['joursSemaineUDP'].markAsDirty();
    this.affectationsSupplier = new FournisseurLivraisonsAffectationSupplier(this.selectedJourSemaineList, this.selectedSecteurFournisseurList, this.uniteDeProduction, this.livraisonsOfUDP, false);
  };

  saveLivraisons = async (): Promise<void> => {
    if (!this.canWrite()) return;
    if (this.displayNavFournisseurs()) {
      this.setAffectations();
    }
    if (this.form.valid) {
      let udp = this.udpSvc.prepareJoursLivraisonDispo(this.uniteDeProduction, this.selectedJourSemaineList);
      udp = this.udpSvc.prepareSecteurs(udp, this.selectedSecteurList);
      udp.uniteDeProduction__secteurFournisseurList = this.udpSvc.prepareSecteursFournisseurs(udp, this.livraisonsOfUDP);

      const response = await this.udpSvc.saveLivraisons(udp, this.livraisonsOfUDP).toPromise();

      if (this.utils.isResponseSupplierError(response)) {
        this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.ERROR, 'Erreur lors de la sauvegarde des livraisons.');
        return;
      }

      await this.adminService.majAllergenes().toPromise();

      this.udpSvc.announceSavedDTO(response);
      this.uniteDeProduction = response.one;
      this.initForm(this.uniteDeProduction);

      await this.routeMapSvc.goToSecondaryRoute([FS_ROUTES.GUP_UPRO, this.uniteDeProduction.id, 'livraisons']);

      this.toastSvc.displayToast(
        MSG_KEY.ROOT,
        MSG_SEVERITY.SUCCESS,
        `Enregistrement des livraisons de l'unité de production ${this.uniteDeProduction.libelle.toUpperCase()} réalisé avec succès`
      );

      const isConfirmed = await confirm('Souhaitez-vous lancer la mise à jour des articles préférés ?', 'Confirmation');
      if (isConfirmed) {
        const searchResponse = await this.gds.search(this.udpReglePrefereSvc.filterByIdUniteDeProduction(this.uniteDeProduction.id)).toPromise();
        const udpRegle = searchResponse.resultList[0];
        if (udpRegle) {
          this.udpReglePrefereSvc.calculerArticlesPreferes(udpRegle, false).subscribe();
        }
      }
    } else {
      this.gfs.validateAllFormFields(this.form);
    }
  };

  help = (): DialogMsgSupplier => {
    const dms = new DialogMsgSupplier();
    dms.title = 'Paramétrage des jours de livraison';
    dms.logo = 'fa fa-question-circle  yoni-color';

    const p1: Paragraphe = new Paragraphe();
    p1.title = 'Etape 1';
    p1.lines = ['Sélectionner les jours de livraison.'];

    const p2: Paragraphe = new Paragraphe();
    p2.title = 'Etape 2';
    p2.lines = [
      `Sélectionner les secteurs auxquels l'unité de production doit être rattachée.`,
      'Un secteur est une zone géographique.',
    ];

    const p3: Paragraphe = new Paragraphe();
    p3.title = 'Etape 3';
    p3.lines = ['Sélectionner les fournisseurs pouvant livrer sur les secteurs sélectionnés.'];

    const p4: Paragraphe = new Paragraphe();
    p4.title = 'Etape 4';
    p4.lines = ['Affecter les jours de livraison aux fournisseurs choisis.'];

    const p5: Paragraphe = new Paragraphe();
    p5.title = '';
    p5.lines = [
      `<i class="fa fa-info-circle yoni-color"></i>&nbsp;Si vous vous êtes trompé, aller sur un autre onglet et revenez sur 'LIVRAISONS' pour recharger l'état initial.`,
      `N'oubliez pas d'enregistrer&nbsp;<i class="fa fa-smile-o yoni-color"></i>.`,
    ];

    dms.content = {intro: 'Les livraisons se paramètrent en 4 étapes.', paragraphes: [p1, p2, p3, p4, p5]};
    return dms;
  };

  tooltipSecteurFournisseur = (secteurFournisseur: SecteurFournisseurDTO): string => {
    let response = secteurFournisseur.fournisseurLibelle;
    if (!secteurFournisseur.actif) {
      response += ' Attention : le secteur fournisseur est inactif';
    }
    if (!secteurFournisseur.fournisseurActif) {
      response += ' Attention : la filiale est inactive';
    }
    return response + ' (Site : ' + secteurFournisseur.secteur.site.libelle + ')';
  };

  getNbSecteursFournisseursActifs = (): number => this.selectedSecteurFournisseurList.length;

  setAffectations = (): void => {
    if (this.utils.isCollectionNullOrEmpty(this.livraisonsOfUDP)) {
      this.livraisonsOfUDP = [];
    }
    this.affectationsSupplier.secteursFournisseurs = _sortBy(this.affectationsSupplier.secteursFournisseurs, ['secteur.code', 'fournisseurLibelle']);

    const newLivraisonsOfUDP: UniteDeProduction__LivraisonDTO[] = [];
    for (const row of this.affectationsSupplier.secteursFournisseurs) {
      for (const col of this.affectationsSupplier.joursSemaine) {
        let elt = this.utils.getFirstElement(this.livraisonsOfUDP.filter(item => {
          if (item.idSecteurFournisseur === row.id && item.numeroJourSemaine === col.value) {
            if (item.actif === undefined) item.actif = true;
            return true;
          }
          return false;
        }));

        if (this.utils.isNullOrEmpty(elt)) {
          elt = new UniteDeProduction__LivraisonDTO();
          elt.idSecteurFournisseur = row.id;
          elt.numeroJourSemaine = col.value;
          elt.actif = this.affectationsSupplier.newIsChecked;
          elt.delaiLivraisonHeureLimite = this.utils.setHour(new Date(), 16);
          elt.delaiLivraisonJours = 0;
        }
        newLivraisonsOfUDP.push(elt);
      }
    }
    this.livraisonsOfUDP = [...newLivraisonsOfUDP];
  };

  loadUdpLivraison(uniteDeProduction: UniteDeProductionDTO): void {
    this.udpSecteurFournisseurSvc.getUdpLivraisonList(uniteDeProduction.id)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((response: ResponseWrapper<UniteDeProduction__LivraisonDTO>) => {
        this.livraisonsOfUDP = response.resultList;
      });
  }

  goToTabLivraison = (event: any): void => {
    const item = event?.itemData;
    if (!item) return;
    this.activeItem = this.navUpLivraison.find(tab => tab.label === item.label) || item;
    this.activeItemDx = item;
    if (item.routerLink) {
      this.router.navigate(item.routerLink as any[], {relativeTo: this.route, queryParams: item.queryParams});
    }
  };

  private tabRouteSubscription = (): void => {
    this.route.queryParamMap
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(params => this.applyLivraisonTabState(params.get('tab')));
  };

  private applyLivraisonTabState(tabKey: string | null): void {
    const normalizedKey = tabKey === 'planning-livraison' ? 'planning-livraison' : 'fournisseur';
    this.displayNavFournisseurs.set(normalizedKey === 'fournisseur');
    this.activeItem = this.navUpLivraison.find(tab => tab.queryParams?.tab === normalizedKey) || this.navUpLivraison[0];
    this.activeItemDx = this.navUpLivraisonDx.find(tab => tab.label === this.activeItem?.label) || this.navUpLivraisonDx[0];
  }

  private ensureDefaultLivraisonTab(): void {
    if (this.route.snapshot.queryParamMap.get('tab')) return;
    this.router.navigate([], {relativeTo: this.route, queryParams: {tab: 'fournisseur'}, replaceUrl: true});
  }
}
